/* ============================================================
   B1 Obere Leiste und B2 blauer Hauptheader
   - Höhen als CSS-Variablen (obere Leiste schiebt sich heraus, Kategorieleiste darunter)
   - Leiste ganz oben sichtbar, beim Herunterscrollen weich ausgeblendet
   - Aktion: Countdown „Startet in“ / „Endet in“, Code kopieren, automatisches Zurückschalten
   - Aufklappmenüs und Sprachauswahl: Hover, Klick, Enter, Escape
   Referenz: Vorschau mse/preview.js und promo.js
   ============================================================ */
(function () {
  var root = document.documentElement;

  /* ---------- Höhen ---------- */
  function measure() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    var bar = section.querySelector('.mse-topbar');
    var barH = bar ? bar.offsetHeight : 0;
    root.style.setProperty('--mse-topbar-h', barH + 'px');
    root.style.setProperty('--mse-bluehead-h', section.offsetHeight - barH + 'px');
  }

  var observed = null;
  function observe() {
    var section = document.querySelector('.section-header');
    if (!section || section === observed) return;
    observed = section;
    if (window.ResizeObserver) new ResizeObserver(measure).observe(section);
  }

  /* ---------- Leiste beim Scrollen ---------- */
  function onScroll() {
    root.classList.toggle('mse-scrolled', window.scrollY > 8);
  }

  /* ---------- Aktion ---------- */
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  var promoTimer = null;
  function initPromo() {
    clearInterval(promoTimer);
    var bar = document.querySelector('.mse-topbar[data-promo-end], .mse-topbar[data-promo-start]');
    if (!bar || !window.mseBerlin) return;
    var promo = bar.querySelector('.mse-promo');
    var std = bar.querySelector('.mse-topbar__std');
    if (!promo) return;
    var start = window.mseBerlin(bar.getAttribute('data-promo-start'));
    var end = window.mseBerlin(bar.getAttribute('data-promo-end'));
    var label = promo.querySelector('.mse-promo__cdl');
    var parts = {};
    promo.querySelectorAll('[data-cd]').forEach(function (el) {
      parts[el.getAttribute('data-cd')] = el;
    });

    function off() {
      clearInterval(promoTimer);
      bar.classList.remove('is-promo');
      promo.hidden = true;
      if (std) std.hidden = false;
      measure();
    }

    function tick() {
      var now = new Date();
      if (end && now >= end) return off();
      var before = start && now < start;
      var target = before ? start : end;
      if (label) label.textContent = before ? 'Startet in' : 'Endet in';
      if (!target || !parts.s) return;
      var s = Math.max(0, Math.floor((target - now) / 1000));
      parts.d.textContent = Math.floor(s / 86400) + ' T';
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      parts.s.textContent = pad(s % 60);
    }

    if (end && new Date() >= end) return off();
    bar.classList.add('is-promo');
    promo.hidden = false;
    if (std) std.hidden = true;
    tick();
    promoTimer = setInterval(tick, 1000);
    measure();
  }

  /* Code anklicken kopiert ihn, Anzeige kurz „Kopiert ✓“ */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.mse-promo__code');
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    try {
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
    } catch (e) {}
    btn.textContent = 'Kopiert ✓';
    btn.classList.add('is-copied');
    clearTimeout(btn._mseT);
    btn._mseT = setTimeout(function () {
      btn.textContent = code;
      btn.classList.remove('is-copied');
    }, 2000);
  });

  /* ---------- Aufklappmenüs ---------- */
  if (!customElements.get('mse-header-nav')) {
    customElements.define(
      'mse-header-nav',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.items = Array.prototype.slice.call(this.querySelectorAll('.mse-nav__item--dd'));
          this.items.forEach(function (item) {
            var btn = item.querySelector('.mse-nav__link');
            var timer;
            item.addEventListener('mouseenter', function () {
              clearTimeout(timer);
              self.open(item);
            });
            item.addEventListener('mouseleave', function () {
              timer = setTimeout(function () {
                self.close(item);
              }, 120);
            });
            btn.addEventListener('click', function () {
              item.classList.contains('is-open') ? self.close(item) : self.open(item);
            });
            item.addEventListener('keydown', function (event) {
              if (event.key === 'Escape' && item.classList.contains('is-open')) {
                self.close(item);
                btn.focus();
              }
            });
            item.addEventListener('focusout', function (event) {
              if (!item.contains(event.relatedTarget)) self.close(item);
            });
          });
        }

        open(item) {
          this.items.forEach(
            function (other) {
              if (other !== item) this.close(other);
            }.bind(this)
          );
          item.classList.add('is-open');
          item.querySelector('.mse-nav__link').setAttribute('aria-expanded', 'true');
        }

        close(item) {
          item.classList.remove('is-open');
          item.querySelector('.mse-nav__link').setAttribute('aria-expanded', 'false');
        }

        closeAll() {
          this.items.forEach(this.close.bind(this));
        }
      }
    );
  }

  /* ---------- Sprachauswahl ---------- */
  if (!customElements.get('mse-header-lang')) {
    customElements.define(
      'mse-header-lang',
      class extends HTMLElement {
        connectedCallback() {
          var btn = this.querySelector('.mse-lang__btn');
          var menu = this.querySelector('.mse-lang__menu');
          var self = this;
          function set(open) {
            menu.hidden = !open;
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          }
          btn.addEventListener('click', function () {
            set(menu.hidden);
            if (!menu.hidden) {
              var current = menu.querySelector('[aria-current="true"]') || menu.querySelector('button');
              if (current) current.focus();
            }
          });
          this.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && !menu.hidden) {
              set(false);
              btn.focus();
            }
          });
          this.addEventListener('focusout', function (event) {
            if (!self.contains(event.relatedTarget)) set(false);
          });
          document.addEventListener('click', function (event) {
            if (!self.contains(event.target)) set(false);
          });
        }
      }
    );
  }

  function init() {
    observe();
    measure();
    initPromo();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
